module.exports = __webpack_public_path__ + "img/20210830_215944.57ca015f.jpg";